export default __webpack_public_path__ + "0edf7821f65ec824e02bb79ce1054ee5.svg";